import { Collapse } from 'antd';
import styled from 'styled-components';

export const PortalContainer = styled.div`
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 10% 10%,
      rgba(110, 185, 160, 0.14),
      transparent 30%
    ),
    radial-gradient(
      circle at 90% 90%,
      rgba(53, 109, 159, 0.1),
      transparent 28%
    ),
    linear-gradient(180deg, #f5fbf8 0%, #edf3fb 100%);
  padding: 24px 16px 48px;

  @media (max-width: 640px) {
    padding: 12px 10px 24px;
  }
`;

export const PortalShell = styled.div`
  max-width: 900px;
  margin: 0 auto;

  @media (max-width: 640px) {
    max-width: 100%;
  }
`;

export const PortalHeader = styled.header`
  padding: 24px 28px;
  border-radius: 22px;
  background: linear-gradient(140deg, #155d4b 0%, #1f725f 52%, #356d9f 100%);
  color: #ffffff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  .patient-info {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .patient-avatar {
    width: 50px;
    height: 50px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .patient-name {
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: #f6fff9;
    margin: 0 0 2px;
  }

  .patient-subtitle {
    font-size: 0.84rem;
    color: rgba(240, 255, 248, 0.72);
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 10px;
    line-height: 1.4;
  }

  .logout-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.24);
    color: #f0fff6;
    font-size: 0.84rem;
    border-radius: 10px;
    padding: 6px 14px;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.18);
    }
  }

  @media (max-width: 640px) {
    padding: 14px;
    border-radius: 16px;
    margin-bottom: 12px;

    .patient-info {
      width: 100%;
      gap: 10px;
    }

    .patient-avatar {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      font-size: 18px;
    }

    .patient-name {
      font-size: 1.02rem;
    }

    .patient-subtitle {
      font-size: 0.78rem;
      gap: 2px 8px;
    }

    .logout-btn {
      width: 100%;
      margin-top: 2px;
      padding: 8px 12px;
    }
  }
`;

export const PortalSectionTitle = styled.h2`
  font-size: 1.05rem;
  font-weight: 700;
  color: #134f3d;
  letter-spacing: -0.01em;
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProfileCard = styled.div`
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(18, 62, 51, 0.06);

  .tab-label {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
  }

  .ant-tabs-nav {
    margin-bottom: 12px;
  }

  .ant-tabs-tab {
    padding: 8px 10px !important;
  }

  .ant-tabs-content-holder {
    overflow: hidden;
  }

  .profile-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;

    @media (max-width: 640px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 480px) {
      grid-template-columns: 1fr;
      gap: 8px;
    }
  }

  @media (max-width: 640px) {
    padding: 12px;
    border-radius: 14px;
    margin-bottom: 12px;

    .ant-tabs-tab {
      padding: 6px 8px !important;
      font-size: 0.82rem;
    }

    .tab-label {
      gap: 4px;
    }
  }
`;

export const ProfileField = styled.div`
  .field-label {
    font-size: 0.76rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #7a9e8e;
    margin-bottom: 3px;
  }

  .field-value {
    font-size: 0.97rem;
    font-weight: 600;
    color: #1e4f3c;
  }
`;

export const SchedulesList = styled.div`
  display: grid;
  gap: 10px;
`;

export const ScheduleCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(18, 62, 51, 0.05);
  display: flex;
  align-items: center;
  gap: 16px;

  .schedule-date-block {
    flex-shrink: 0;
    width: 54px;
    height: 54px;
    border-radius: 14px;
    background: linear-gradient(140deg, #edf7f2 0%, #e8f2fb 100%);
    border: 1px solid rgba(36, 95, 73, 0.12);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: 1;

    .day {
      font-size: 1.35rem;
      font-weight: 800;
      color: #1b5c8f;
    }

    .month {
      font-size: 0.68rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #2f6754;
    }
  }

  .schedule-info {
    flex: 1;
    min-width: 0;
  }

  .schedule-title {
    font-size: 0.97rem;
    font-weight: 600;
    color: #1e4f3c;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .schedule-meta {
    font-size: 0.84rem;
    color: #4d7a68;
    margin-top: 2px;
  }

  .schedule-status {
    flex-shrink: 0;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 0.76rem;
    font-weight: 600;
    background: #e8f7ef;
    color: #1e7a4e;
    border: 1px solid rgba(30, 122, 78, 0.18);

    &.pending {
      background: #fff8e6;
      color: #8a6a1c;
      border-color: rgba(138, 106, 28, 0.18);
    }

    &.cancelled {
      background: #fff0f0;
      color: #b83232;
      border-color: rgba(184, 50, 50, 0.18);
    }
  }

  @media (max-width: 640px) {
    padding: 12px;
    border-radius: 12px;
    gap: 10px;
    flex-wrap: wrap;

    .schedule-date-block {
      width: 46px;
      height: 46px;
      border-radius: 12px;

      .day {
        font-size: 1.1rem;
      }

      .month {
        font-size: 0.62rem;
      }
    }

    .schedule-info {
      min-width: calc(100% - 56px);
    }

    .schedule-title {
      white-space: normal;
      line-height: 1.3;
      font-size: 0.9rem;
    }

    .schedule-meta {
      margin-top: 4px;
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      font-size: 0.8rem;
    }

    .schedule-status {
      margin-left: auto;
    }
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(24, 90, 66, 0.08);

  .empty-icon {
    font-size: 40px;
    margin-bottom: 12px;
    opacity: 0.4;
  }

  p {
    color: #4d7a68;
    font-size: 0.95rem;
    margin: 0;
  }

  @media (max-width: 640px) {
    padding: 24px 12px;
    border-radius: 14px;

    .empty-icon {
      font-size: 32px;
      margin-bottom: 8px;
    }

    p {
      font-size: 0.86rem;
    }
  }
`;

export const FinancialSummary = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;

  .summary-item {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid rgba(24, 90, 66, 0.1);
    padding: 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .label {
      font-size: 0.78rem;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      color: #7a9e8e;
    }

    .value {
      font-size: 1.2rem;
      font-weight: 700;
    }

    &.open .value {
      color: #c97a0a;
    }

    &.paid .value {
      color: #1e7a4e;
    }
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 8px;

    .summary-item {
      padding: 10px 12px;

      .value {
        font-size: 1.02rem;
      }
    }
  }
`;

export const FinancialCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  padding: 14px 18px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  box-shadow: 0 2px 6px rgba(18, 62, 51, 0.04);

  &.paid {
    opacity: 0.7;
  }

  &.cancelled .fin-desc {
    text-decoration: line-through;
    color: #9e9e9e;
  }

  .fin-left {
    flex: 1;
    min-width: 0;
  }

  .fin-desc {
    font-size: 0.95rem;
    font-weight: 600;
    color: #1e4f3c;
    margin-bottom: 3px;
  }

  .fin-dates {
    font-size: 0.8rem;
    color: #4d7a68;
  }

  .fin-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    flex-shrink: 0;
  }

  .fin-value {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e4f3c;
  }

  @media (max-width: 640px) {
    padding: 10px 12px;
    border-radius: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    .fin-left {
      width: 100%;
    }

    .fin-desc {
      font-size: 0.9rem;
    }

    .fin-right {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

export const DocCard = styled.div`
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(18, 62, 51, 0.04);
`;

export const DocCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  background: linear-gradient(90deg, #edf7f2 0%, #e8f2fb 100%);
  border-bottom: 1px solid rgba(24, 90, 66, 0.08);
  font-size: 0.88rem;
  font-weight: 600;
  color: #1e4f3c;
  flex-wrap: wrap;

  .doc-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .doc-actions {
    margin-left: auto;
  }

  .print-btn {
    border: 1px solid rgba(31, 114, 95, 0.22);
    background: #ffffff;
    color: #1f725f;
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 0.78rem;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #f4fbf8;
      border-color: rgba(31, 114, 95, 0.45);
    }
  }

  @media (max-width: 640px) {
    padding: 10px 12px;
    font-size: 0.8rem;

    .doc-actions {
      width: 100%;
      margin-left: 0;
    }

    .print-btn {
      width: 100%;
      justify-content: center;
      padding: 7px 10px;
      font-size: 0.76rem;
    }
  }
`;

export const DocCardBody = styled.div`
  padding: 14px 16px;
  font-size: 0.9rem;
  color: #2e4d3c;
  line-height: 1.6;
  max-height: 320px;
  overflow-y: auto;

  p {
    margin: 0 0 8px;
  }

  @media (max-width: 640px) {
    padding: 10px 12px;
    font-size: 0.84rem;
    max-height: 220px;
  }
`;

export const FormRecordsCollapse = styled(Collapse)`
  display: grid;
  gap: 12px;
  background: transparent;

  .ant-collapse-item {
    overflow: hidden;
    border-radius: 14px !important;
    border: 1px solid rgba(24, 90, 66, 0.1) !important;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(18, 62, 51, 0.04);
  }

  .ant-collapse-header {
    align-items: flex-start !important;
    padding: 14px 16px !important;
    background: linear-gradient(90deg, #edf7f2 0%, #e8f2fb 100%);
  }

  .ant-collapse-content {
    border-top: 1px solid rgba(24, 90, 66, 0.08);
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }

  .form-collapse-label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    min-width: 0;
  }

  .form-collapse-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-size: 0.88rem;
    font-weight: 600;
    color: #1e4f3c;
  }

  .form-collapse-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e4f3c;
  }

  .form-collapse-subtitle {
    font-size: 0.84rem;
    color: #4d7a68;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 12px;
  }

  .form-collapse-body {
    padding: 18px;
    display: grid;
    gap: 16px;
  }

  .form-section-title {
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #678a7b;
    margin-bottom: 10px;
  }

  .form-description {
    margin: 10px 0 0;
    color: #406a5b;
    line-height: 1.55;
  }

  .form-fields-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
  }

  .form-field-card,
  .form-evolution-card {
    border: 1px solid rgba(24, 90, 66, 0.1);
    border-radius: 14px;
  }

  .form-field-card {
    background: #f8fbfa;
    padding: 12px;
  }

  .form-field-label {
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #7a9e8e;
    margin-bottom: 4px;
  }

  .form-field-value {
    font-size: 0.92rem;
    color: #1f4237;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .form-evolutions-list {
    display: grid;
    gap: 10px;
  }

  .form-evolution-card {
    background: #ffffff;
    padding: 14px;
  }

  .form-evolution-header {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }

  .form-evolution-meta {
    font-weight: 600;
    color: #1e4f3c;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 10px;
  }

  .form-evolution-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .form-evolution-text {
    color: #406a5b;
    white-space: pre-wrap;
    line-height: 1.55;
  }

  @media (max-width: 640px) {
    gap: 10px;

    .ant-collapse-header {
      padding: 12px !important;
    }

    .form-collapse-body {
      padding: 12px;
    }

    .form-fields-grid {
      grid-template-columns: 1fr;
    }

    .form-collapse-title {
      font-size: 0.92rem;
    }

    .form-collapse-subtitle,
    .form-collapse-meta {
      font-size: 0.8rem;
    }
  }
`;

export const TreatmentCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid rgba(24, 90, 66, 0.1);
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(18, 62, 51, 0.05);

  .treatment-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 10px;
  }

  .treatment-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    color: #4d7a68;
  }

  .treatment-type {
    font-weight: 700;
    color: #1e4f3c;
    font-size: 0.95rem;
  }

  .treatment-total {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e4f3c;
    flex-shrink: 0;
  }

  .treatment-items {
    margin-top: 10px;
    display: grid;
    gap: 6px;
  }

  .treatment-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    border-radius: 10px;
    background: #f5fbf8;
    border: 1px solid rgba(24, 90, 66, 0.08);
    cursor: default;
    font-size: 0.87rem;

    &.status-2 {
      opacity: 0.6;
    }
  }

  .item-name {
    flex: 1;
    color: #1e4f3c;
    font-weight: 500;
  }

  .item-qty {
    color: #4d7a68;
    font-size: 0.8rem;
  }

  .item-value {
    font-weight: 600;
    color: #1e4f3c;
  }

  @media (max-width: 640px) {
    padding: 12px;
    border-radius: 12px;

    .treatment-header {
      flex-direction: column;
      gap: 6px;
      margin-bottom: 8px;
    }

    .treatment-meta {
      font-size: 0.8rem;
      line-height: 1.4;
    }

    .treatment-total {
      font-size: 0.95rem;
    }

    .treatment-item {
      flex-wrap: wrap;
      gap: 6px;
      padding: 8px;
    }

    .item-name {
      width: 100%;
      font-size: 0.83rem;
    }

    .item-qty,
    .item-value {
      font-size: 0.76rem;
    }
  }
`;

export const TreatmentProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .prog-label {
    font-size: 0.78rem;
    color: #4d7a68;
    white-space: nowrap;
  }

  @media (max-width: 640px) {
    flex-wrap: wrap;
    gap: 6px;

    .prog-label {
      font-size: 0.74rem;
    }
  }
`;
